<a *ngIf="chip.link" [href]="chip.link">{{chip.name}}</a>
<span *ngIf="!chip.link">{{chip.name}}</span>
